<script lang="ts">
    import { Notification } from "svelma/src";

    import { onMount } from "svelte";
    import { navigate } from "svelte-navigator";
    import * as _ from "underscore";
    import type {
        UserResponse,
        Permission,
        ResourceType,
    } from "../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { permissionsArray } from "../../../../GlobalHelper/Permissions";
    import { organisationStore } from "../../../../store/organisations";
    import { user } from "../../../../store/stores";
    import { usersStore } from "../../../../store/users";
    import PermissionsTable from "./Components/PermissionsTable.svelte";

    export let id: string;

    let userDetails: UserResponse;

    const changePermissionsHandler = (
        permissions: Permission[],
        resourceType: ResourceType
    ) => {
        console.log(permissions, resourceType, $usersStore);
        usersStore.update((usersStore) => {
            return {
                ...usersStore,
                userAccessGrant: [
                    {
                        ...(usersStore.userAccessGrant[0]
                            ? usersStore.userAccessGrant[0]
                            : {}),
                        toUser: {
                            active: true,
                            orphan: false,
                            ...usersStore.user,
                        },
                        fromOrganisation: {
                            active: true,
                            ...$organisationStore.organisation,
                        },
                        permissions: usersStore.userAccessGrant[0]?.permissions
                            .filter(
                                (permissionDescript) =>
                                    permissionDescript.resourceType !==
                                    resourceType
                            )
                            .concat([
                                {
                                    resourceType,
                                    permissions,
                                    targetResourceIds: ["*"],
                                },
                            ]) || [
                            {
                                resourceType,
                                permissions,
                                targetResourceIds: ["*"],
                            },
                        ],
                    },
                ],
                // {
                //     ...usersStore.userAccessGrant,
                //     permissions: [
                //         ...usersStore.userAccessGrant.permissions.map(
                //             (permissionsObject, index) => {
                //                 if (index === 0)
                //                     return {
                //                         ...usersStore.userAccessGrant
                //                             .permissions[0],
                //                         permissions: [...permissions],
                //                     };
                //                 return permissionsObject;
                //             }
                //         ),
                //     ],
                // }
            };
        });
    };

    let showDeleteOverlay: boolean = false;

    const toggleDeleteOverlay = () => (showDeleteOverlay = !showDeleteOverlay);

    const deleteUser = async () => {
        await $user.updateToken().then(async () => {
            const updateUser = userDetails;
            delete updateUser.id;
            await ApiClient.getInstance($user)
                .userClient.deleteUserAuthorizationUserIdContextOrganisation({
                    userId: id,
                    authorization: $user.token,
                })
                .then(() => {
                    usersStore.update((usersStore) => {
                        return {
                            ...usersStore,
                            user: null,
                            userPermissions: [],
                        };
                    });
                    navigate(-1);
                });
        });
    };

    const statusHandler = (status: number) => {
        switch (status) {
            case 201:
                Notification.create({
                    message: "Nutzer wurde gespeichert",
                    type: "is-success is-light",
                });
                break;
        }
    };

    const updateUser = async () => {
        await $user.updateToken().then(async () => {
            const updateUser = userDetails;
            // delete updateUser.id;
            await ApiClient.getInstance($user)
                .userClient.updateUserAuthorizationUserIdContextOrganisation({
                    authorization: $user.token,
                    userId: id,
                    contextOrganisation: $organisationStore.organisation.id,
                    userUpdateRequest: {
                        username: userDetails.username,
                        firstName: userDetails.firstName,
                        lastName: userDetails.lastName,
                        email: userDetails.email,
                        permissions: $usersStore.userPermissions,
                        organisationId: $organisationStore.organisation.id,
                        active: userDetails.active,
                    },
                })
                .then((user) => {
                    usersStore.update((usersStore) => {
                        userDetails = { ...user };
                        return {
                            ...usersStore,
                            user: { ...user },
                        };
                    });
                    statusHandler(201);
                });

            $usersStore.userAccessGrant.forEach((accessGrant) => {
                if (accessGrant.id) {
                    ApiClient.getInstance(
                        $user
                    ).accessGrantClient.updateAccessGrant({
                        accessGrantId: accessGrant.id,
                        accessGrantRequest: {
                            toUser: $usersStore.user.id,
                            fromOrganisation:
                                $organisationStore.organisation.id,
                            permissions: accessGrant.permissions,
                        },
                    });
                    return;
                }
                ApiClient.getInstance(
                    $user
                ).accessGrantClient.createAccessGrant({
                    accessGrantRequest: {
                        toUser: $usersStore.user.id,
                        fromOrganisation: $organisationStore.organisation.id,
                        permissions: accessGrant.permissions,
                    },
                });
            });
        });
    };

    const getUser = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .userClient.getUserAuthorizationUserIdContextOrganisation({
                    userId: id,
                    authorization: $user.token,
                })
                .then((user) => {
                    usersStore.update((usersStore) => {
                        userDetails = { ...user };
                        return {
                            ...usersStore,
                            user: { ...user },
                        };
                    });
                    return user;
                })
                .then((userEdit) =>
                    ApiClient.getInstance($user)
                        .accessGrantClient.listAccessGrants({
                            authorization: $user.token,
                        })
                        .then((allAccessGrants) =>
                            allAccessGrants.entries.filter(
                                (accessGrant) =>
                                    accessGrant.toUser.id === userEdit.id &&
                                    accessGrant.fromOrganisation.id === "0"
                            )
                        )
                )
                .then((accessGrants) => {
                    accessGrants.forEach(async (accessGrant) => {
                        await ApiClient.getInstance($user)
                            .accessGrantClient.getAccessGrant({
                                accessGrantId: accessGrant.id,
                            })
                            .then((accessGrantResp) => {
                                console.log(accessGrantResp);
                                usersStore.update((usersStore) => {
                                    return {
                                        ...usersStore,
                                        userAccessGrant: [
                                            ...usersStore.userAccessGrant,
                                            accessGrantResp,
                                        ],
                                    };
                                });
                            });
                    });
                });
        });
    };

    // const getRolesPermissionMapping = async () => {
    //     await $user.updateToken().then(async () => {
    //         await ApiClient.getInstance($user)
    //             .accessGrantClient.listAccessGrants({})
    //             .then(console.log);
    //     });
    // };

    const getContextOrganisation = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .userAuthorityClient.getContextOrganisationId({})
                .then((orgaId) =>
                    organisationStore.update((organisationStore) => {
                        return {
                            ...organisationStore,
                            organisation: {
                                ...organisationStore.organisation,
                                id: orgaId,
                            },
                        };
                    })
                );
        });
    };

    console.log($usersStore.userPermissions);

    onMount(async () => {
        await getContextOrganisation();
        getUser();
    });

    $: changedUser =
        userDetails && $usersStore.user && $usersStore.userAccessGrant
            ? _.isEqual(userDetails, $usersStore.user) &&
              _.isEqual($usersStore.userAccessGrant, [])
            : true;
</script>

<div class="columns">
    <div class="column is-12">
        {#if userDetails}
            <div class="card">
                <div class="card-content">
                    <div class="content">
                        <div class="columns is-multiline">
                            <div class="column is-12">
                                <div class="what">Nutzer bearbeiten</div>
                            </div>
                            <div class="column is-12">
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">Username</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <p class="control">
                                                <input
                                                    class="input "
                                                    type="email"
                                                    bind:value={userDetails.username}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">E-Mail</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <p class="control">
                                                <input
                                                    class="input "
                                                    type="email"
                                                    bind:value={userDetails.email}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">Status</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="select">
                                            <select
                                                bind:value={userDetails.active}
                                            >
                                                <option value={true}
                                                    >aktiv</option
                                                >
                                                <option value={false}
                                                    >deaktiviert</option
                                                >
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">Vorname</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <p class="control">
                                                <input
                                                    class="input "
                                                    type="email"
                                                    bind:value={userDetails.firstName}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">Nachname</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <p class="control">
                                                <input
                                                    class="input "
                                                    type="email"
                                                    bind:value={userDetails.lastName}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="column is-12">
                                <PermissionsTable
                                    accessGrantDescriptors={$usersStore?.userAccessGrant.filter(
                                        (accessGrant) =>
                                            accessGrant.toUser.id === id
                                    )[0]?.permissions || []}
                                    editable
                                    {changePermissionsHandler}
                                />
                            </div>
                            <div class="column is-12 ">
                                <div class="columns is-multiline first-row">
                                    <div
                                        class="column is-one-third is-flex is-justify-content-flex-start"
                                    >
                                        <button
                                            class="button gradient-left"
                                            on:click={() => navigate(-1)}
                                        >
                                            zurück
                                        </button>
                                    </div>
                                    <div
                                        class="column is-one-third is-flex is-justify-content-flex-start"
                                    >
                                        <button
                                            class="button gradient-left"
                                            disabled={changedUser}
                                            style="margin: auto;"
                                            on:click={() => updateUser()}
                                        >
                                            Änderungen speichern
                                        </button>
                                    </div>
                                    <div
                                        class="column is-one-thirdis-flex is-justify-content-flex-end"
                                    >
                                        <button
                                            class="button is-danger is-light"
                                            style="float: right;"
                                            on:click={() =>
                                                (showDeleteOverlay = true)}
                                        >
                                            Profil löschen
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/if}

        {#if showDeleteOverlay}
            <div class="modal is-active">
                <div
                    class="modal-background"
                    on:click={() => toggleDeleteOverlay()}
                />
                <div class="modal-content">
                    <div class="box">
                        <div class="columns is-multiline">
                            <div class="column is-12">
                                <p class="is-size-6">
                                    Möchten Sie dieses Profil wirklich löschen?
                                </p>
                            </div>
                            <div class="column is-6">
                                <button
                                    class="button gradient-left"
                                    on:click={() => toggleDeleteOverlay()}
                                >
                                    Abbrechen
                                </button>
                            </div>
                            <div class="column is-6">
                                <button
                                    class="button is-danger is-light"
                                    style="float: right;"
                                    on:click={() => deleteUser()}
                                >
                                    Ja
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    class="modal-close is-large"
                    aria-label="close"
                    on:click={() => toggleDeleteOverlay()}
                />
            </div>
        {/if}
    </div>
</div>

<style>
    .container {
        padding-top: 1rem;
    }
    .box {
        height: 100%;
        overflow: auto;
    }

    .card {
        border-radius: 100px;
        padding: 2rem 4rem;
    }

    .label {
        text-align: left;
        font-weight: 600 !important;
        font-size: 1.3rem;
        padding-top: 0.375rem;
    }

    .background-beige {
        background-color: #e6e6e6;
    }

    select {
        background-image: linear-gradient(
            to right,
            #14acab 0%,
            #238aae 51%,
            #2765af 100%
        ) !important;
        color: white !important;
    }

    ::after {
        border-color: white !important;
    }

    .what {
        font-weight: 700;
        font-size: 1.7rem;
        padding-bottom: 2rem;
    }

    .field-label {
        flex-grow: 1.5 !important;
    }
</style>
